import { TooltipContainer } from "@outplayed/tooltips";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getTierColor } from "@ugg/shared/utils/tier-helpers";
import { numberWithCommas } from "@ugg/shared/utils/math";

interface Datum {
  delta?: number;
  type?: string;
  champion_id: number;
  wins: number;
  matches: number;
  win_rate: number;
  sec_win_rate: number;
}

interface ChampionCounterTooltipProps {
  curChampionId: number;
  secChampionId: number;
  datum: Datum;
}

const ChampionCounterTooltip = (props: ChampionCounterTooltipProps) => {
  const { getChampionImgFromSprite } = getRiotAssetsContext();
  const { curChampionId, secChampionId, datum } = props;

  if (datum.delta) {
    return (
      <div className="tooltip-item tooltip-champion-counter">
        <div className="current-champion">{getChampionImgFromSprite(curChampionId, { size: 24 })}</div>
        <div className="win-comparison">
          wins &nbsp;
          <span>{`${Math.abs(datum.delta)}%`}</span>
          &nbsp;
          {datum.delta >= 0 ? <i style={{ color: "#08a6ff" }}>MORE</i> : <i style={{ color: "#ff4e50" }}>LESS</i>}
          &nbsp;
          {datum.type === "team" ? "with" : "vs"}
        </div>
        <div className="counter-champion">{getChampionImgFromSprite(secChampionId, { size: 24 })}</div>
        <div className="total-matches">
          <span>Matches:</span>
          &nbsp;
          {numberWithCommas(datum.matches)}
        </div>
      </div>
    );
  } else {
    const curWinRate = 100 - datum.win_rate;

    return (
      <div className="tooltip-item tooltip-champion-counter">
        <div className="current-champion">{getChampionImgFromSprite(secChampionId, { size: 24 })}</div>
        <div className="win-comparison">
          wins &nbsp;
          <span className={getTierColor(curWinRate)}>{curWinRate.toFixed(1)}%</span>
          &nbsp;
          {datum.type === "team" ? "with" : "vs"}
        </div>
        <div className="counter-champion">{getChampionImgFromSprite(curChampionId, { size: 24 })}</div>
        <div className="total-matches">
          <span>Matches:</span>
          &nbsp;
          {numberWithCommas(datum.matches)}
        </div>
      </div>
    );
  }
};

interface ChampionCounterProps {
  data: {
    curChampionId: number;
    secChampionId: number;
    datum: Datum;
  };
  dim?: number;
  children?: React.ReactNode;
}

const ChampionCounter = (props: ChampionCounterProps) => {
  const { getChampionImgFromSprite } = getRiotAssetsContext();
  const { data, dim, children } = props;
  const { curChampionId, secChampionId, datum } = data;

  const img = children || getChampionImgFromSprite(secChampionId, { size: dim || 30 });

  const tooltipInfo = <ChampionCounterTooltip curChampionId={curChampionId} secChampionId={secChampionId} datum={datum} />;

  return <TooltipContainer tooltipInfo={tooltipInfo}>{img}</TooltipContainer>;
};

export default ChampionCounter;
